module.exports = __webpack_public_path__ + "fcb2bfb30eddcfc51eb3bc97c5f1143c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/talking.png
// module id = 1216
// module chunks = 0